import React, { useEffect, useState } from 'react';
import { Typography } from "@mui/material";

import { LogoConfig } from "@/types";


let clientComponentMap: Record<string, React.ComponentType<any>> = {}

export function getClientComponent<TProps>(
  name: string,
  fallback: React.ComponentType<TProps>
): React.ComponentType<TProps> {
  return clientComponentMap[name] as React.ComponentType<TProps>|| fallback;
}

// type ClientComponentProps<TProps> = {
//   name: string;
//   fallback: React.ComponentType<TProps>;
// } & TProps;
//
// export function ClientComponent<TProps>(props: ClientComponentProps<TProps>): JSX.Element {
//   const { name, fallback, ...rest } = props;
//   const Component = getClientComponent<TProps>(name, fallback);
//   return React.createElement(Component, rest as TProps) as JSX.Element;
//   // return <Component {...(rest as TProps)} />;
// }

export async function preloadClientComponents() {
  const client = process.env.REACT_APP_CLIENT;

  if (!client) return;

  try {
    const { componentMap } = await import((`@/components/client/${client}/componentMap`));
    clientComponentMap = componentMap;
  } catch {
    clientComponentMap = {};
  }
}

export const useLogo = () => {

  const [config, setConfig] = useState<LogoConfig | null>(null);

  useEffect(() => {
    const client = process.env.REACT_APP_CLIENT || 'core';

    const load = async () => {
      const configModule = await import(`@/assets/logos/${client}/config`);
      setConfig(configModule.logoConfig);
    }

    load();
  }, []);

  return config;
};

export const useConnectLogo = (mode: string) => {

  const [logo, setLogo] = useState<React.ComponentType | null>(null);

  const defaultLogo = () => (
    <Typography
      variant="h1"
      sx={{
        textAlign: "center",
        fontFamily: "cera-pro-bold",
      }}
    >
      —CONNECT—
    </Typography>
  )

  useEffect(() => {
    const client = process.env.REACT_APP_CLIENT || 'core';

    const load = async () => {
      try {
        const logoModule = await import(`@/assets/logos/${client}/ConnectLogo`);
        setLogo(() => logoModule.default);
      } catch (err) {
        if (client !== 'core') {
          if (mode === 'dark') {
            const logoModule = await import(`@/assets/logos/${client}/Logo`);
            setLogo(() => logoModule.default);
          } else {
            const logoModule = await import(`@/assets/logos/${client}/LogoDark`);
            setLogo(() => logoModule.default);
          }
        } else {
          setLogo(() => defaultLogo);
        }
      }
    }

    load();

  }, [mode])

  return logo

}

export const getPageConfig = () => {
  const client = process.env.REACT_APP_CLIENT || 'core';

  console.log('CLIENT', client);

  if (client === 'gravity') {
    return {
      title: 'Gravity Connect'
    }
  } else if (client === 'miroma') {
    return {
      title: 'Miroma Prism'
    }
  } else {
    return {
      title: 'CONNECT'
    }
  }

}
